import { ImageLink } from "../atoms/Links";
import { SOCIAL_LINKS } from "../../static/constants";
import { map } from 'lodash';
export const SocialLinks = () => (<div className='mtb-20'>
    {map(SOCIAL_LINKS, (lnk, itr) => (<span key={`social-link-${itr}`}><ImageLink href={lnk.linkAddress} src={lnk.imgSrc} alt={`Social-link-${itr}`} /></span>))}
</div>)